import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage"; 
const firebaseConfig = {
  apiKey: "AIzaSyBF7QjtmIr4nTmRIw9Y9ugg2X2jlcRQxPU",
  authDomain: "fairdeal-a3075.firebaseapp.com",
  projectId: "fairdeal-a3075",
  storageBucket: "fairdeal-a3075.appspot.com",
  messagingSenderId: "924153818723",
  appId: "1:924153818723:web:d134a253fe3aff4e32d256",
  measurementId: "G-HDR6YSSE0F",
};

export const app = initializeApp(firebaseConfig);
export const dataBase = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
// const analytics = getAnalytics(app);